import React from 'react'
import { SelectField, SelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { capitalizeFirstLetter } from 'utils-next/string'

import { UserRole } from '../../../../../../../../../entities-next/user'

export type UserRoleSelectProps = Omit<SelectFieldProps, 'options' | 'getOptionLabel'>

const userRoles = [UserRole.manager, UserRole.member, UserRole.collaborator]

function getUserRoleLabel(role: UserRole) {
  return capitalizeFirstLetter(role)
}

export function UserRoleSelect(selectProps: UserRoleSelectProps) {
  return <SelectField options={userRoles} getOptionLabel={getUserRoleLabel} {...selectProps} />
}
